module.exports = __webpack_public_path__ + "img/gnu_smart_gallery2.f5b53733.jpg";